<template>
    <div :class="$style.promo_list">
        <LinkSwitcher
            v-for="{ location, title, id } in categories"
            :key="id"
            :class="$style.switcher"
            :title="title"
            :icon="id"
            :to="location"
            dataInterfaceTarget="search-promo-category"
        />
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'

import LinkSwitcher from '@/components/LinkSwitcher.vue'
import { useGeneralData } from '@/query/use-general-data'
import { shuffle } from '@/utils/helpers'

const { mainData } = useGeneralData()

const categories = computed(() =>
    shuffle(mainData.value.promoCategoriesList).slice(0, Math.min(7, mainData.value.promoCategoriesList.length)),
)
</script>
<style module>
.switcher {
    padding: 6px 12px;
}
.promo_list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

@media (--desktop-small-plus) {
    .promo_list {
        gap: 8px;
        height: 38px;
        opacity: 0;
        animation: appear 0s linear 200ms forwards;
    }
}

@keyframes appear {
    to {
        height: auto;
        opacity: 1;
    }
}
</style>
